import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import Link from '../../Link';
import InspectionStatusBadge from '../InspectionStatusBadge/InspectionStatusBadge';
import { getInspectionEntry } from '../../../helpers/inspectionPresentation';
import s from '../Inspection.css';

// "Check-in" / "Check-out" buttons with their status badge, in the reservation lists and in the trip details.
// States: not open yet, to do, to validate, validated, dispute. Nothing is rendered when the admin switched the feature off.
export function InspectionEntries({ reservation, userType }) {
  const { formatMessage } = useIntl();
  const entries = ['checkin', 'checkout']
    .map((type) => getInspectionEntry({ reservation, type, userType }))
    .filter(Boolean);
  if (!entries.length) return null;
  return (
    <div className={s.entries}>
      {entries.map((entry) => {
        const label = formatMessage(entry.type === 'checkin' ? messages.inspCheckinTitle : messages.inspCheckoutTitle);
        return (
          <span key={entry.type} className={s.entry}>
            {entry.state === 'closed'
              ? <span className={s.summaryMuted}>{label}</span>
              : <Link to={entry.link} className={s.entryLink}>{label}</Link>}
            <InspectionStatusBadge entry={entry} />
          </span>
        );
      })}
    </div>
  );
}

InspectionEntries.propTypes = { reservation: PropTypes.object, userType: PropTypes.string.isRequired };

export default withStyles(s)(InspectionEntries);
